export default __webpack_public_path__ + "static/media/logo.09891ed0.svg";